import ServerVariablesForm_default from "./ServerVariablesForm.vue.js";
export { ServerVariablesForm_default as ServerVariablesForm };
